export const environment = {
    production: false,
    clientId: '439685f5-8bc9-4b25-8b48-e4a19c489d56',
    authority: 'https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22/',
    apiScopes: ['api://4228213e-a48f-4f81-950a-58d623a2e301/user_impersonation'],
    apiBaseUrl: 'https://dev.apigat.accenture.com',
    sentryDsn: 'https://07ba654d40edf865ecf00eb7ca0fa0c7@tnv-sentry.umlaut-cloud.com/15',
    version: '1.0.4'
  };
  